import { createApi } from '@halobear/request'

import { PROXY } from '@/constants'
import { getToken } from './authority'
import { handle401 } from './handle'

export default createApi({
  config: { baseURL: PROXY, shouldLoading: true, shouldToast: true },
  requestHandler(config) {
    const token = getToken()
    token && (config.headers.Authorization = `Bearer ${token}`)
    return config
  },
  errorHandler(e) {
    const { status } = (e || {}).response || {}
    if (status === 401) {
      handle401()
    }
  },
})